// 6s
const SNACKBAR_DURATION = 6000;

export { SNACKBAR_DURATION };
